export interface GridDragInputEvent {
  type?: string;
  pointerType?: string;
  sourceCapabilities?: {
    firesTouchEvents?: boolean;
  };
}

interface CanStartGridDragFromEventOptions {
  allowTouchInput?: boolean;
}

const touchGeneratedMouseEvents = new WeakSet<GridDragInputEvent>();

export const markTouchGeneratedMouseEvent = <T extends GridDragInputEvent>(
  event: T
): T => {
  touchGeneratedMouseEvents.add(event);

  return event;
};

const isTouchGeneratedMouseEvent = (event?: GridDragInputEvent): boolean =>
  Boolean(
    event &&
      (touchGeneratedMouseEvents.has(event) ||
        event.sourceCapabilities?.firesTouchEvents)
  );

export const canStartGridDragFromEvent = (
  event?: GridDragInputEvent,
  options: CanStartGridDragFromEventOptions = {}
): boolean => {
  if (!event) {
    return true;
  }

  if (
    event.type?.startsWith('touch') ||
    (event.pointerType && event.pointerType !== 'mouse')
  ) {
    return Boolean(options.allowTouchInput);
  }

  if (isTouchGeneratedMouseEvent(event)) {
    return false;
  }

  return true;
};
